export default __webpack_public_path__ + "57f07a00cc7a5a663d61017a1e035a63.png";